import React from 'react'
import './footer.css'
import { SiCodeforces, SiLeetcode } from 'react-icons/si'
import { SiGeeksforgeeks } from 'react-icons/si'
import {SiCodechef} from 'react-icons/si'

const Footer = () => {
  return (
    <footer>
      <a href="#" className="footer_logo">
        Parshant Goyal
      </a>
      <ul className="permalinks">
        <li>
          <a href="#">Home</a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#skills">Skills</a>
        </li>
        <li>
          <a href="#experience">Experience</a>
        </li>
        <li>
          <a href="#portfolio">Projects</a>
        </li>
        <li>
          <a href="#achievements">Achievements</a>
        </li>
        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>

      <div className="footer_socials">
        <a href="https://leetcode.com/u/Parshantgoyal479/" target="_blank">
          <SiLeetcode />
        </a>
        <a
          href="https://www.geeksforgeeks.org/profile/goyalpars2eg5"
          target="_blank"
        >
          <SiGeeksforgeeks />
        </a>
        <a href="https://www.codechef.com/users/wide_muse_90" target="_blank">
          <SiCodechef />
        </a>
        <a href="https://codeforces.com/profile/goyalparshant362" target="_blank">
          <SiCodeforces />
        </a>
      </div>
      <div className='footer_copyright'>
        <small>
          &copy; Parshant Goyal : All rights reserved.
          </small>
      </div>
    </footer>
  );
}

export default Footer